import { Project } from '@/api'
import { PROJECT_KEY } from '@/constants/localStorage'
import vuetify from '@/plugins/vuetify'

const state = {
    id: null,
    name: null,
    nameEui: null,
    attributes: {},
}

const getters = {
    getProjectNameEui(state) {
        return state.nameEui
    },
    getProjectAttributes(state) {
        return state.attributes
    },
}

const actions = {
    async setProject({ commit, dispatch, state }, project) {
        try {
            const projectData = await Project.get(project.name_eui)
            if (state.nameEui !== projectData.data.name_eui) {
                commit('groups/RESET', null, { root: true })
                commit('gateways/RESET', null, { root: true })
                localStorage.removeItem('selectedGroup')
                localStorage.removeItem('metersv2')
            }
            localStorage.setItem(PROJECT_KEY, project.name_eui)
                    commit('SET_PROJECT', projectData.data)
        } catch (error) {
            throw JSON.parse(error.request.response)
        }
        dispatch('app/set_initial_language', null, { root: true })
    },
    async unsetProject({ commit }) {
        localStorage.removeItem(PROJECT_KEY)
        localStorage.removeItem('selectedGroup')
        localStorage.removeItem('metersv2')
        commit('groups/RESET', null, { root: true })
        commit('gateways/RESET', null, { root: true })

        commit('SET_PROJECT', {
            id: null,
            name: null,
            name_eui: null,
            attributes: {},
        })
    },
    async loadSavedProject({ commit, state }) {
        const projectSaved = localStorage.getItem(PROJECT_KEY)
        if (!projectSaved) return

        const projectData = await Project.get(projectSaved)
        if (state.nameEui !== projectData.data.name_eui) {
            commit('groups/RESET', null, { root: true })
            commit('gateways/RESET', null, { root: true })
            localStorage.removeItem('selectedGroup')
            localStorage.removeItem('metersv2')
        }
        commit('SET_PROJECT', projectData.data)
    },
    async updateAttributes({ commit }, { name, data }) {
        await Project.updateAttributes(name, data)
        commit('UPDATE_ATTRIBUTES', { name, data })
    },
}

const mutations = {
    SET_PROJECT(state, project) {
        const { _id, name, name_eui, attributes = {} } = project
        if(!attributes?.lightsRegistered) attributes.lightsRegistered = []
        state.id = _id
        state.name = name
        state.nameEui = name_eui
        state.attributes = attributes
    },
    UPDATE_ATTRIBUTES(state, { name, data }) {
        state.attributes[name] = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
